import { ArchiAppSectionsKeyType } from '../../keys/models/archiAppSections';

const archiAppSections: ArchiAppSectionsKeyType = {
  singular: 'Archi app section',
  plural: 'Archi app sections',
  create: 'Create section',
  update: 'Edit section',
  delete: 'Delete section',
  selectSection: 'Select section'
};

export default archiAppSections;
